import React, { forwardRef } from "react";
import {
  MdOutlinePersonOutline,
  MdPersonOutline,
  MdLogout,
} from "react-icons/md";
import { FaStar } from "react-icons/fa";
import { BsBookmark } from "react-icons/bs";
import { MdOutlineSupportAgent } from "react-icons/md";
import { Link } from "react-router-dom";

const ProfileDropdown = forwardRef(
  ({ profileDropdownOpen, setProfileDropdownOpen, onSignOut }, ref) => {
    return (
      <div
        className="d-flex align-items-center gap-2"
        onClick={() => setProfileDropdownOpen(!profileDropdownOpen)}
        style={{ cursor: "pointer", position: "relative" }}
        ref={ref}
      >
        <MdOutlinePersonOutline color="#ffffff" fontSize={28} />
        {profileDropdownOpen && (
          <div
            className="dropdown-menu-px show position-absolute p-2 shadow rounded left-170"
            style={{
              backgroundColor: "#fff",
              zIndex: 1000,
              left: "170px !important",
              top: "30px",
              padding: "10px 15px",
              width: "200px",
            }}
          >
            <Link to={"/preference?activeTab=profile"} className="no-underline">
              <div
                className="dropdown-item d-flex align-items-center gap-2"
                style={{
                  cursor: "pointer",
                  padding: "8px 0",
                  fontWeight: "bolder",
                }}
              >
                <MdPersonOutline /> profile
              </div>
            </Link>
            <Link to={"/preference?activeTab=rated"} className="no-underline">
              <div
                className="dropdown-item d-flex align-items-center gap-2"
                style={{
                  cursor: "pointer",
                  padding: "8px 0",
                  fontWeight: "bolder",
                }}
              >
                <FaStar /> Rated Managers
              </div>
            </Link>

            <Link to={"/preference?activeTab=saved"} className="no-underline">
              <div
                className="dropdown-item d-flex align-items-center gap-2"
                style={{ cursor: "pointer", padding: "8px 0" }}
              >
                <BsBookmark /> Saved Managers
              </div>
            </Link>

            <Link to={"/contact-us"} className="no-underline">
              <div
                className="dropdown-item d-flex align-items-center gap-2 no-underline"
                style={{ cursor: "pointer", padding: "8px 0" }}
              >
                <MdOutlineSupportAgent /> Contact Us
              </div>
            </Link>
            <div
              className="dropdown-item d-flex align-items-center gap-2 text-danger"
              onClick={onSignOut}
              style={{ cursor: "pointer", padding: "8px 0" }}
            >
              <MdLogout /> sign out
            </div>
          </div>
        )}
      </div>
    );
  }
);

ProfileDropdown.displayName = "ProfileDropdown";

export default ProfileDropdown;
